<div
  class="flex items-center gap-3 font-sans font-medium"
  [ngClass]="containerClass">
  <div *ngIf="selectedContact">
    <div
      class="inline-flex items-center overflow-hidden rounded-md transition-all focus-within:ring-2 focus-within:ring-primary/20">
      <fa-icon
        *ngIf="showIcon"
        class="pl-1 text-xs text-primary"
        [icon]="faPhone"></fa-icon>

      <a
        class="px-1 py-1 text-sm text-slate-900 transition-colors hover:text-primary-dark"
        target="_blank"
        rel="noopener noreferrer"
        [href]="selectedContact.whatsappUrl"
        >{{ selectedContact.display }}</a
      >
      <button
        type="button"
        aria-label="Select phone number"
        aria-haspopup="listbox"
        [attr.aria-expanded]="isDropdownOpen"
        (click)="toggleDropdown($event)"
        class="flex items-center gap-1 border-l border-primary/20 px-2 py-1 text-primary transition-colors hover:bg-primary/10">
        <svg
          class="h-4 w-4 transition-transform"
          [ngClass]="isDropdownOpen ? 'rotate-180' : 'rotate-0'"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true">
          <path
            fill-rule="evenodd"
            d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.25 8.29a.75.75 0 0 1-.02-1.08Z"
            clip-rule="evenodd" />
        </svg>
      </button>
    </div>
    <p-popover
      #overlayPanel
      [appendTo]="'body'"
      [dismissable]="true"
      [styleClass]="
        'mt-2 w-60 overflow-hidden rounded-md border border-slate-200 bg-white shadow-lg'
      "
      (onShow)="onPanelShow()"
      (onHide)="onPanelHide()">
      <div class="flex flex-col bg-white">
        <a
          *ngFor="let phone of contacts"
          [href]="phone.whatsappUrl"
          target="_blank"
          rel="noopener noreferrer"
          (click)="selectContact(phone)"
          class="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-slate-900 transition-colors hover:bg-slate-50"
          [class.bg-slate-100]="phone === selectedContact"
          [class.font-semibold]="phone === selectedContact">
          <span class="h-1.5 w-1.5 rounded-full bg-primary"></span>
          <span>{{ phone.display }}</span>
        </a>
      </div>
    </p-popover>
  </div>
</div>
